import React, { useState, useContext, Dispatch, SetStateAction } from "react"

type LoadingState = boolean | undefined

const MutationLoadingStatusContext = React.createContext<{
  isLoading?: LoadingState
  setIsLoading: Dispatch<SetStateAction<LoadingState>>
}>({
  setIsLoading: _value => {
    throw new Error("useMutationLoadingStatus cannot be used outside of MutationLoadingStatusProvider.")
  }
})

function MutationLoadingStatusProvider({ children }: { children?: React.ReactNode }) {
  const [isLoading, setIsLoading] = useState<LoadingState>(undefined)
  return (
    <MutationLoadingStatusContext.Provider value={{ isLoading, setIsLoading }}>
      {children}
    </MutationLoadingStatusContext.Provider>
  )
}

export const useMutationLoadingStatus = () => useContext(MutationLoadingStatusContext)

export { MutationLoadingStatusProvider }
